<div class="container">
  <div class="conteudoInscricao">
    <h2>{{ mensagemTitulo }}</h2>
    <!-- <input type="text" name="senha" [(ngModel)]="senhaID" class="modal-input0"> -->
    <!-- <button *ngIf="notificacaoPermitida != 'granted'" (click)="iniciarSolicitacao()">Ativar Notificações</button> -->
    <div *ngIf="mensagem">
      <!-- <p>Pagina aberta para Inscrição.</p> -->
      <p>{{ mensagem }}</p>
      <p>Sua senha é {{ senhaNotificacao }}</p>
    </div>
  </div>
</div>
